import zod from "zod";

export const ModuleLayoutTabsUserDataSchema = zod.object({
  paths: zod.array(zod.string()),
});

export const AdminTabsPersistedStateSchema = zod.object({
  paths: zod.array(zod.string()),
  pinnedLeft: zod.array(zod.string()),
});

export const DataGridExpandedRowsSchema = zod.array(zod.string());

export const DataGridPersistedStateSchema = zod.object({
  columns: zod.object({
    columnVisibilityModel: zod.record(zod.string(), zod.boolean()),
    orderedFields: zod.array(zod.string()),
    dimensions: zod.record(
      zod.string(),
      zod.object({
        width: zod.number(),
        minWidth: zod.number(),
        maxWidth: zod.number(),
      }),
    ),
  }),
  pinnedColumns: zod.object({
    left: zod.array(zod.string()),
    right: zod.array(zod.string()),
  }),
});
